<template>
  <notifications
      position="bottom center"
      :width="400"
  >
    <template slot="body"
              slot-scope="{ item, close }">

      <div :class="['notif', item.type ? `notif--${item.type}` : 'notif--success']">

        <div class="notif__icon-wrap">
          <v-icon size="20" color="white">{{ notifIcon(item.type) }}</v-icon>
        </div>

        <div class="notif__body">
          <div class="notif__title">{{ item.title }}</div>
          <div v-if="item.text" class="notif__text">{{ item.text }}</div>
        </div>

        <div class="notif__actions">
          <router-link
              v-if="item.data && item.data.to"
              :to="item.data.to"
              class="notif__link"
          >
            <v-icon size="16" color="white">mdi-arrow-right</v-icon>
          </router-link>
          <button class="notif__close" @click="close">
            <v-icon size="14" color="white">mdi-close</v-icon>
          </button>
        </div>

      </div>
    </template>
  </notifications>
</template>

<script>
export default {
  name: "NotificationTemplate",
  methods: {
    notifIcon(type) {
      const icons = {
        error: 'mdi-alert-circle',
        info:  'mdi-information',
      };
      return icons[type] || 'mdi-check-circle';
    }
  }
}
</script>

<style lang="scss">

.notif {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 8px 12px 0;
  padding: 12px 14px;
  border-radius: 12px;
  color: white;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.22);
  animation: notif-in 0.22s ease;
  backdrop-filter: blur(6px);
  background-color: rgba(67, 160, 71, 0.72);

  &--error   { background-color: rgba(229, 57, 53, 0.72); }
  &--info    { background-color: rgba(251, 140, 0, 0.72); }
  &--success { background-color: rgba(67, 160, 71, 0.72); }

  &__icon-wrap {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    align-self: center;
  }

  &__body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.3;
  }

  &__text {
    font-size: 12px;
    opacity: 0.88;
    margin-top: 3px;
    line-height: 1.4;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
  }

  &__link {
    display: flex;
    align-items: center;
    opacity: 0.85;
    text-decoration: none;
    transition: opacity 0.15s;
    &:hover { opacity: 1; }
  }

  &__close {
    display: flex;
    align-items: center;
    opacity: 0.7;
    cursor: pointer;
    background: none;
    border: none;
    padding: 2px;
    border-radius: 4px;
    transition: opacity 0.15s, background 0.15s;

    &:hover {
      opacity: 1;
      background: rgba(255, 255, 255, 0.15);
    }
  }
}

// Margen del borde inferior del navegador (sobreescribe el inline style de la librería)
.vue-notification-group {
  bottom: 24px !important;
}

@keyframes notif-in {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

</style>
